import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
const Container = styled.svg`
  &:hover {
    cursor: pointer;
    fill: #1570ef;
    path {
      fill: #fff;
    }
  }
  &:disabled,
  &[disabled],
  &[disabled]:hover,
  &[disabled]:focus {
    cursor: no-drop;
    fill: #e9e9e9;
    path {
      fill: #fff;
    }
    rect {
      stroke: #e9e9e9;
    }
  }
`;

function PenToSquareRegular({ navigatePath, disabled }) {
  const navigate = useNavigate();
  return (
    <Container
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      rx="3"
      xmlns="http://www.w3.org/2000/svg"
      onClick={() => {
        if (disabled) {
        } else {
          navigate(`${navigatePath}`);
        }
      }}
      disabled={disabled}
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="3" stroke="#057AFF" />
      <path
        d="M17.1682 6.38897C16.6496 5.87034 15.8112 5.87034 15.2926 6.38897L14.5798 7.09941L16.8982 9.41783L17.611 8.70502C18.1297 8.18639 18.1297 7.34807 17.611 6.82944L17.1682 6.38897ZM10.0827 11.5989C9.93823 11.7434 9.82693 11.921 9.76299 12.1175L9.06202 14.2204C8.99334 14.4241 9.04781 14.6491 9.19937 14.803C9.35093 14.9569 9.5759 15.009 9.78193 14.9404L11.8848 14.2394C12.079 14.1731 12.2566 14.0641 12.4035 13.9197L16.3654 9.9554L14.0446 7.63461L10.0827 11.5989ZM8.27342 7.3907C7.0183 7.3907 6 8.409 6 9.66412V15.7266C6 16.9817 7.0183 18 8.27342 18H14.3359C15.591 18 16.6093 16.9817 16.6093 15.7266V13.4532C16.6093 13.034 16.2707 12.6953 15.8515 12.6953C15.4323 12.6953 15.0937 13.034 15.0937 13.4532V15.7266C15.0937 16.1457 14.755 16.4844 14.3359 16.4844H8.27342C7.85426 16.4844 7.51562 16.1457 7.51562 15.7266V9.66412C7.51562 9.24496 7.85426 8.90631 8.27342 8.90631H10.5468C10.966 8.90631 11.3047 8.56766 11.3047 8.1485C11.3047 7.72934 10.966 7.3907 10.5468 7.3907H8.27342Z"
        fill="#057AFF"
      />
    </Container>
  );
}

export default PenToSquareRegular;
